/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsPerDateDto } from '../../models/submissions-per-date-dto';

export interface DashboardSubmissionsPerDateGet$Plain$Params {
  fromDate?: string;
  toDate?: string;
}

export function dashboardSubmissionsPerDateGet$Plain(http: HttpClient, rootUrl: string, params?: DashboardSubmissionsPerDateGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsPerDateDto>>> {
  const rb = new RequestBuilder(rootUrl, dashboardSubmissionsPerDateGet$Plain.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsPerDateDto>>;
    })
  );
}

dashboardSubmissionsPerDateGet$Plain.PATH = '/Dashboard/submissions-per-date';
